export const balanceUtil = (value, decimal) => {
  decimal = 18;
  if (!value) return '--';
  if (value == '0') return 0;
  let i = value.length;
  if (i <= decimal) {
    while (i < decimal) {
      value = '0' + value;
      i++;
    }
    console.log('0.' + value);
    return '0.' + value;
  }

  const value1 = value.substr(0, value.length - decimal);
  const value2 = value.substr(value.length - decimal, value.length);
  return Number(value1 + '.' + value2);
};

export const getTime = (str) => {
  const date = new Date(str * 1000);

  const month = date.getMonth() + 1;
  const day = date.getDate();
  const Hour = date.getHours();
  const minutes = date.getMinutes();
  return `${month}-${day} ${Hour}:${minutes}`;
};

export const getXY = (index) => {
  if (index == 0) {
    return {
      x: 0,
      y: 0,
    };
  }
  const x = Math.floor(index % 50);
  const y = Math.ceil(index / 50) - 1;
  return { x, y };
};

const ff = (num) => {
  return num < 10 ? `0${num}` : num;
};

export const getFullTime = (str) => {
  const date = new Date(str * 1000);
  const year = date.getFullYear();
  const month = ff(date.getMonth() + 1);
  const day = ff(date.getDate());
  const Hour = ff(date.getHours());
  const minutes = ff(date.getMinutes());
  return `${year}-${month}-${day} ${Hour}:${minutes}`;
};

export const numberUtils = (number, decimal) => {
  number = number + '';
  let a = number.indexOf('.'); //小数点位置
  let f_count = 0; //小数位后位数
  if (a > 0) {
    if (f_count > decimal) {
      console.log('输入错误');
      return;
    }
    f_count = number.slice(a + 1).length;
  }
  let b = decimal - f_count;
  let c = '';
  for (let i = 0; i < b; i++) {
    c += '0';
  }
  number = number.replace('.', '') + c; //替换小数点，进行补0
  while (number[0] == '0') {
    //删除掉数字前面的0
    number = number.slice(1);
  }
  return number;
};

export const cutNumber = (val, bool) => {
  if (!val) {
    return '--';
  }
  if (Number(val) > 10000000) {
    return (Number(val) / 1000000).toFixed(2) + 'M';
  } else if (Number(val) < 10000000 && Number(val) > 100000) {
    return (Number(val) / 1000).toFixed(2) + 'K';
  } else {
    return bool ? Number(val).toFixed(2) : val;
  }
};
export const getUrl = (nftid) => {
  let url =
    'https://' +
    'images' +
    getDir(Math.ceil(nftid / 3600)) +
    '.netlify.app/images' +
    Math.ceil(nftid / 3600) +
    '/' +
    nftid +
    '.png';
  return url;
};

function getDir(nftid) {
  switch (nftid) {
    case 1:
      return '1-3';
    case 2:
      return '1-3';
    case 3:
      return '1-3';
    case 4:
      return '4-7';
    case 5:
      return '4-7';
    case 6:
      return '4-7';
    case 7:
      return '4-7';
    case 8:
      return '8-11';
    case 9:
      return '8-11';
    case 10:
      return '8-11';
    case 11:
      return '8-11';
    case 12:
      return '12-15';
    case 13:
      return '12-15';
    case 14:
      return '12-15';
    case 15:
      return '12-15';
    case 16:
      return '16-19';
    case 17:
      return '16-19';
    case 18:
      return '16-19';
    case 19:
      return '16-19';
    case 20:
      return '20-23';
    case 21:
      return '20-23';
    case 22:
      return '20-23';
    case 23:
      return '20-23';
    case 24:
      return '24-25';
    case 25:
      return '24-25';
  }
}

export const mathFloor = (number, digit) => {
  if (isNaN(Number(number)) || isNaN(Number(digit))) {
    return 0;
  }
  return (
    Math.floor(number * Math.pow(10, digit) + 1 / Math.pow(10, 9 - digit)) /
    Math.pow(10, Number(digit))
  ).toFixed(Number(digit));
};
